/**
 * siteStats.js — single source of truth for *copy-level* site metrics.
 *
 * Any user-visible marketing claim about tree size, member count,
 * state coverage, etc. should either:
 *   1. Import from this file (preferred for narrative/historical copy
 *      that doesn't need to track the live DB), OR
 *   2. Fetch the live number from GET /api/family-trees/discover
 *      (preferred when the number should be exactly current).
 *
 * This replaces the hardcoded "324 members" strings that the
 * 2026-10-06 SEO audit flagged as inconsistent with the live DB count
 * of 313 (gap: 11 private/living members excluded from public counts).
 *
 * The number here is phrased as a floor ("over X") so day-to-day DB
 * fluctuations don't make the copy false.
 */

// Vellaringattu Family — the first and currently flagship public tree.
// Floor-rounded so the live count can shift ±a few without the copy
// becoming inaccurate.
export const VELLARINGATTU_MEMBER_FLOOR = 300;
export const VELLARINGATTU_MEMBER_PHRASE = "over 300 members";

// Site-wide marketing numbers (updated manually when they genuinely
// cross a round milestone). For live dashboards, call the discover API.
export const SITE_HERO_TAGLINE = "Start preserving your family history today — the first lineage of what will be many.";
